import { useContext, useRef, useState, useEffect } from "react";
import Select from "react-select";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import AgGridTable from "../../utilities/AgGridTable";
import { ForwardInfoContext } from "../Logistic";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkNumber, emailValidation } from "../../utilities/FormValidation";
import { useNavigate } from "react-router-dom";

const initialValue = {
  containerPlanId: "",
  name: "",
  contact: "",
  emailAddress: "",
  uuid:""
};

const ForwarderInfo = () => {
  // const [forwardInfoDialog, setForwardInfoDialog] =
  //   useContext(ForwardInfoContext);
  const containersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlans}`;
  const forwarderInfoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.saveForwarderInfo}`;

  const gridRef = useRef();
  const navigate = useNavigate();
  const [rowData, setRowData] = useState();
  const [forwarderInfoData, setForwarderInfoData] = useState(initialValue);
  const [containerOptions, setContainerOptions] = useState([]);
  const [validError, setValidError] = useState({});
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [saveDisable, setSaveDisable] = useState(true);

  const [columnDefs, setColumnDefs] = useState([
    { field: "loadingWeek", enableRowGroup: true },
    { field: "country", enableRowGroup: true },
    { field: "containerNo", enableRowGroup: true },
    { field: "plannedContainerType", enableRowGroup: true },
  ]);

  const handleChange = (event, name) => {
    if (name === "containerPlanId") {
      setForwarderInfoData({
        ...forwarderInfoData,
        containerPlanId: event.value,
      });
    } else {
      setForwarderInfoData({
        ...forwarderInfoData,
        [event.target.name]: event.target.value,
      });
    }
  };


  const handleSubmit = async () => {
    setCheckSubmit(true);
    forwarderInfoData.contact = parseInt(forwarderInfoData.contact);
    const forwarderInfo = await OAuthService.addData(
      forwarderInfoUrl,
      forwarderInfoData
    );
  };

  useEffect(() => {
    if (
      forwarderInfoData.containerPlanId &&
      forwarderInfoData.name &&
      forwarderInfoData.contact &&
      forwarderInfoData.emailAddress && !validError.emailAddress && !validError.contact
    ) {
      setSaveDisable(false);
    } else {
      setSaveDisable(true);
    }
  }, [
    forwarderInfoData.containerPlanId &&
      forwarderInfoData.name &&
      forwarderInfoData.contact &&
      forwarderInfoData.emailAddress,
      validError
  ]);

  return (
    <>

      <div className="flex flex-col items-center p-24 sm:p-40 container">
        <div className="flex flex-col w-full max-w-4xl">
          {/* <div className="sm:mt-32">
            <Button
              color="secondary"
              startIcon={
                <FuseSvgIcon>heroicons-outline:arrow-narrow-left</FuseSvgIcon>
              }
              onClick={() => {
                window.close();
              }}
            >
              Back to Dashboard
            </Button>
          </div> */}
          <div className="mt-8 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight">
            Forwarder Info
          </div>

          <Paper className="mt-32 sm:mt-48 p-24 pb-28 sm:p-40 sm:pb-28 rounded-2xl">
            <div className="mb-24">
              <Typography className="text-2xl font-bold tracking-tight">
                Submit your request
              </Typography>
            </div>
            <div className="space-y-32">
              {/* <Stack>
                <label>Select Container No</label>
                <Select
                  name="containerPlanId"
                  value={
                    forwarderInfoData.containerPlanId &&
                    containerOptions &&
                    containerOptions.filter(
                      (obj) => forwarderInfoData.containerPlanId === obj.value
                    )
                  }
                  onChange={(data) => handleChange(data, "containerPlanId")}
                  options={containerOptions}
                  styles={customStyles()}
                />
              </Stack> */}

              <Stack>
                <label>*Name</label>
                <TextField
                  className="mb-16"
                  variant="outlined"
                  type="text"
                  name="name"
                  value={forwarderInfoData.name}
                  onChange={(e) => handleChange(e)}
                />
              </Stack>

              <Stack>
                <label>*Contact</label>
                <TextField
                  className="mb-16"
                  variant="outlined"
                  type="text"
                  name="contact"
                  value={forwarderInfoData.contact}
                  inputProps={{ maxLength: 10 }}
                  // onChange={(e)=> handleChange(e)}
                  error={
                    (checkSubmit && !forwarderInfoData.contact) ||
                    validError.contact
                      ? true
                      : false
                  }
                  helperText={
                    checkSubmit && !forwarderInfoData.contact
                      ? ""
                      : validError.contact
                  }
                  onChange={(e) => {
                    handleChange(e);
                    setValidError({
                      ...validError,
                      contact: checkNumber(e.target.value),
                    });
                  }}
                />
              </Stack>

              <Stack>
                <label>*Email</label>
                <TextField
                  className="mb-16"
                  variant="outlined"
                  type="text"
                  name="emailAddress"
                  value={forwarderInfoData.emailAddress}
                  error={
                    (checkSubmit && !forwarderInfoData.emailAddress) ||
                    validError.emailAddress
                      ? true
                      : false
                  }
                  helperText={
                    checkSubmit && !forwarderInfoData.emailAddress
                      ? ""
                      : validError.emailAddress
                  }
                  // onChange={(e) => handleChange(e)}
                  onChange={(e) => {
                    handleChange(e);
                    setValidError({
                      ...validError,
                      emailAddress: emailValidation(e.target.value),
                    });
                  }}
                />
              </Stack>
            </div>

            <div className="flex items-center justify-end mt-32">
              <Button className="mx-8">Cancel</Button>
              <Button
                className="mx-8"
                variant="contained"
                color="warning"
                disabled={saveDisable}
                onClick={handleSubmit}
              >
                Save
              </Button>
            </div>
          </Paper>
        </div>
      </div>
    </>
  );
};

export default ForwarderInfo;
